import { render, staticRenderFns } from "./OneTimePayment.vue?vue&type=template&id=4db9e5f0&scoped=true&"
import script from "./OneTimePayment.vue?vue&type=script&lang=ts&"
export * from "./OneTimePayment.vue?vue&type=script&lang=ts&"
import style0 from "./OneTimePayment.vue?vue&type=style&index=0&id=4db9e5f0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db9e5f0",
  null
  
)

export default component.exports